import React, { useState } from "react";
import Grading from "../components/Programs/Grading";
import Aside from "../modules/SideNav/Aside";

function GradingLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <Grading handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default GradingLayout;
